import React, { ReactNode, useContext, FC, PropsWithChildren } from 'react';

import { getI18nData, useProductUrls } from '@lucid/utils';
import { graphql, useStaticQuery } from 'gatsby';
import { LayoutContext, Link } from '@lucid/components-react';

import { Beacon } from 'types/types';

export interface BeaconElement {
  beaconElementLocation?: Beacon.ElementLocation;
  beaconElementDetail?: string;
}

interface SignUpCtaProps extends BeaconElement {
  children?: ReactNode;
  pageType?: string;
  className?: string;
}

const SignUpCta: FC<PropsWithChildren<SignUpCtaProps>> = ({
  beaconElementDetail,
  beaconElementLocation,
  children,
  pageType,
  className,
  ...other
}) => {
  const {
    language: { i18nKey, urlLangPrefix },
  } = useContext(LayoutContext);

  const { i18nData } = useStaticQuery(
    graphql`
      {
        i18nData: allFile(filter: { sourceInstanceName: { eq: "i18n" } }) {
          edges {
            node {
              name
              childSrcJson {
                mktg_nav_sign_up_free
              }
            }
          }
        }
      }
    `,
  );

  const i18n = getI18nData(i18nData, i18nKey);

  const beaconEvent =
    beaconElementDetail && beaconElementLocation
      ? ({
          name: 'clickedMarketingPageElement',
          elementLocation: beaconElementLocation,
          elementDetail: beaconElementDetail,
          elementType: 'button-primary',
        } as Beacon.Event)
      : null;

  const { pricingUrl } = useProductUrls(urlLangPrefix);

  return (
    <Link
      {...other}
      displayAsButton
      beaconEvent={beaconEvent}
      className={className}
      css={{
        margin: 0,
        paddingLeft: '40px', // TODO: ask Lars why these are here
        paddingRight: '40px',
      }}
      size="large"
      to={pricingUrl}
    >
      {children || i18n('mktg-nav-sign-up-free')}
    </Link>
  );
};

export default SignUpCta;
